import React from "react";
import ReactGA from 'react-ga4';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Amplify, I18n } from "aws-amplify";
import { Authenticator, CheckboxField, useAuthenticator } from "@aws-amplify/ui-react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import "./App.css";
import "@aws-amplify/ui-react/styles.css";
import Navbar from "./components/Navbar";
import Sidebar from "./components/views/SuperAdmin/Sidebar";
import Content from "./components/views/SuperAdmin/Content";
import AdminSidebar from "./components/views/Admin/AdminSidebar"
import AdminContent from "./components/views/Admin/AdminContent";
import FacilitatorSidebar from "./components/views/Facilitator/FacilitatorSidebar";
import FacilitatorContent from "./components/views/Facilitator/FacilitatorContent";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";
import ExpertSidebar from "./components/views/Expert/ExpertSidebar";
import ExpertContent from "./components/views/Expert/ExpertContent";
import KVSReportCard from "./components/KVSReportCard";
import MasterAdminSidebar from "./components/views/MasterAdmin/MasterAdminSidebar";
import MasterAdminContent from "./components/views/MasterAdmin/MasterAdminContent";
import DemoSidebar from "./components/views/Demo/DemoSidebar";
import DemoContent from "./components/views/Demo/DemoContent";
// import MaintenancePage from "./components/MaintenancePage";

import TARAHeader from "./data/tara-header.png"
// import KVSLogo from "./data/KVS-logo.png";
// import TCTDLogo from "./data/TCTD-logo.png";
import GooglePlayStore from "./data/Google-Play-Store.png";

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID,
  },
});

ReactGA.initialize(process.env.REACT_APP_GOOGLE_MEASUREMENT_ID);

function App() {

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  // console.log(authStatus)

  const { t, i18n } = useTranslation();

  // const hiDict = {
  //   "Sign in": "साइन इन",
  // };
  // dictKeys = ["Sign in"]
  // I18n.putVocabularies({ hi: hiDict });
  // I18n.setLanguage(i18n.language)
  
  // useEffect(() => {
  //   if(authStatus === "unauthenticated" && !["/privacy-policy", "/contact-us"].includes(window.location.pathname)){
  //     console.log("trigged")
  //     // window.location.reload()
  //   }
  // }, [authStatus, i18n.language]);

  I18n.putVocabularies({
    "en":{
        "Email": "Email",
        "Enter your Email": "Enter your Email",
        "Password": "Password",
        "Enter your Password": "Enter your Password",
        "Sign in": "Sign In",
        "Signing in": "Signing in",
        "Incorrect username or password.": "Incorrect email or password.",
      },
    "hi":{
        "Email": "ईमेल",
        "Enter your Email": "अपना ईमेल दर्ज करें",
        "Password": "पासवर्ड",
        "Enter your Password": "अपना पासवर्ड दर्ज करें",
        "Sign in": "साइन इन",
        "Signing in": "साइन इन हो रहा है",
        "Incorrect username or password.": "गलत ईमेल या पासवर्ड।"
      },
  })
  I18n.setLanguage(i18n.language)
  
  return (
    <div className="App">
      {/* <Snackbar open={true} sx={{width: {"lg": "20%", "md": "30%", "sm": "45%", "xs": "50%"}, zIndex: "1300"}} >
        <Alert severity={"info"} icon={false}>
          <p style={{fontSize: "13px"}}>By clicking “Accept Necessary Cookies”, you agree TARA can store cookies on your device and disclose information in accordance with our Cookie Policy.</p>
          <Button variant="contained" color="info" sx={{mt: "0.5rem", textTransform: "unset"}} size="small">Accept Necessary Cookies</Button>
        </Alert>
      </Snackbar> */}
      <Router>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
          <Route path="/contact-us" element={<ContactUs />}/>
          <Route path="/kvs-report-card" element={<KVSReportCard/>}/>
          {/* <Route path="*" element={<MaintenancePage />}/> */}
          <Route path="*" element=
            {
              <>
              {authStatus === 'unauthenticated' && <Navbar />}
              <Authenticator
              // variation="modal"
              loginMechanisms={["email"]}
              // formFields={{
              //   signIn: {
              //     username: {
              //       label: t("signedOutUser.signIn.emailLabel"),
              //       placeholder: t("signedOutUser.signIn.emailPlaceholder"),
              //       isRequired: true
              //     },
              //     password: {
              //       label: t("signedOutUser.signIn.passwordLabel"),
              //       placeholder: t("signedOutUser.signIn.passwordPlaceholder"),
              //       isRequired: true
              //     },
              //   }
              // }}
              hideSignUp={true}           // to enable sign up change this to false or comment this
              // socialProviders={["google"]}
              components={{
                Header() {   
                  return (
                    <div className="amplifyHeader">
                      <img alt="TARA Header" src={TARAHeader} style={{width: "100%"}}></img>
                    </div>
                  );
                },
                Footer() {
                  return (
                    <div className="amplifyFooter">
                      <div className="logos">
                        {/* <img alt="KVS logo" src={KVSLogo} />
                        <img alt="TCTD logo" src={TCTDLogo} /> */}
                        <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.prosical.taraapp" style={{display: "inline-block"}}>
                          <img alt="Download on the Play Store" src={GooglePlayStore} style={{ height: "56px", width: "168px", verticalAlign: "middle", objectFit: "contain"}} />
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://apps.apple.com/in/app/tara-reading-assessment-app/id6737688769?itscg=30200&itsct=apps_box_badge&mttnsubad=6737688769" style={{display: "inline-block"}}>
                          <img src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1732579200" alt="Download on the App Store" style={{ height: "56px", width: "168px", verticalAlign: "middle", objectFit: "contain"}} />
                        </a>
                      </div>
                    </div>
                  );
                },
                SignUp: {
                  FormFields() {
                    const { validationErrors } = useAuthenticator();
        
                    return (
                      <>
                        {/* Re-use default `Authenticator.SignUp.FormFields` */}
                        <Authenticator.SignUp.FormFields />
        
                        {/* Append & require Terms & Conditions field to sign up  */}
                        <CheckboxField
                          errorMessage={validationErrors.acknowledgement}
                          hasError={!!validationErrors.acknowledgement}
                          name="acknowledgement"
                          value="yes"
                          label={
                            <>
                              <span>
                                By signing-in, you agree to our
                              </span>
                              <Button 
                                variant="text" 
                                component ={Link}
                                target="_blank"
                                to="/privacy-policy" 
                                sx={{padding: "0", paddingLeft: "0.25rem", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                              >
                                Terms, Privacy Policy & Cookies Policy.
                              </Button>
                            </>
                          }
                        />
                      </>
                    );
                  },
                },
                SignIn: {
                  FormFields() {
                    return (<></>)
                  },
                  Footer() {
                    // const { toResetPassword } = useAuthenticator();
                    
                    return (
                      <div style={{textAlign: "center", paddingBottom: "0.5rem"}}>
                        {/* <div style={{textAlign: "center", paddingBottom: "0.5rem"}}>
                          <span>
                            Trouble signing in?
                          </span>
                          <Button 
                            variant="text" 
                            component ={Link}
                            target="_blank"
                            rel='noopener noreferrer'
                            to="https://forms.gle/fnU48UpGWWs5zgoT6" 
                            sx={{padding: "0", paddingLeft: "0.25rem", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                          >
                            Click Here
                          </Button>
                        </div> */}
                        <span>
                          {t("signedOutUser.signIn.footerTerms")}
                        </span>
                        <Button 
                          variant="text" 
                          component ={Link}
                          target="_blank"
                          to="/privacy-policy" 
                          sx={{padding: "0", paddingLeft: "0.25rem", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                        >
                          {t("signedOutUser.signIn.footerTermsLink")}
                        </Button>
                        {/* <Button
                          onClick={toResetPassword}
                          size="small"
                          variation="link"
                        >
                          Reset Password
                        </Button> */}
                      </div>
                    );
                  },
                },
              }}
              services={{
                async validateCustomSignUp(formData) {
                  if (!formData.acknowledgement) {
                    return {
                      acknowledgement: "You must agree to Terms, Privacy Policy & Cookies Policy.",
                    };
                  }
                },
              }}
              >
                {({ signOut, user }) => (
                  <>
                    {/* {console.log(user)} */}
                    <Navbar 
                      signOut={signOut} 
                      user = {user} 
                    />
                    <div className="mainContent">
                      {/* <Router> */}
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "SuperAdmin" &&
                          <>
                            <Sidebar />
                            <Content />
                          </>
                        }
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "AdminGroup" &&
                          <>
                            <AdminSidebar />
                            <AdminContent />
                          </>
                        }
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "FacilitatorGroup" &&
                          <>
                            <FacilitatorSidebar />
                            <FacilitatorContent />
                          </>
                        }
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "ExpertGroup" &&
                          <>
                            <ExpertSidebar />
                            <ExpertContent />
                          </>
                        }
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "MasterAdminGroup" &&
                          <>
                            <MasterAdminSidebar />
                            <MasterAdminContent />
                          </>
                        }
                        {user.signInUserSession.idToken.payload["cognito:groups"][0] === "DemoGroup" &&
                          <>
                            <DemoSidebar />
                            <DemoContent />
                          </>
                        }
                      {/* </Router> */}
                    </div>
                  </>
                )}
              </Authenticator>
              </>
            }
          />
        </Routes>
        
      </Router>
    </div>
  );
}

export default App;
